import { CircleAlert } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import Paragraph from '../Typography/Paragraph';

interface ErrorMessageProps {
  error: Error | null;
  style?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, style }) => {
  if (!error) return <></>;
  const styles = `flex items-center gap-4 border-2 border-red rounded-theme px-4 py-2 bg-white`;
  const mergedStyles = twMerge(styles, style);
  return (
    <div
      aria-label="Message with an error"
      aria-live="polite"
      data-testid="error-message"
      role="alert"
      className={mergedStyles}
    >
      <CircleAlert
        aria-hidden="true"
        className="self-start mt-1 shrink-0 text-red"
        size={16}
        strokeWidth={1.75}
      />
      <Paragraph text={error?.message ?? 'An unknown error occurred.'} />
    </div>
  );
};

export default ErrorMessage;
